import { PerAdultLabel } from '@/src/components/common/srp/perAdultLabel'
import useSearchResults from '@/src/hooks/srp/useSearchResults'
import { Box, Button, Typography } from '@mui/material'
import { useTranslations } from 'next-intl'
import { Plan } from '../types'
type FareModalFooterProps = {
    selectedPlan: Plan
    handleFareFamilyBook: () => void
    exclusiveBenefits?: string | null
}

function FareModalFooter ({ selectedPlan, handleFareFamilyBook, exclusiveBenefits }: FareModalFooterProps) {
    const hasPrice = !isNaN(selectedPlan.price)
    const t = useTranslations('common')
    const { selectedJourneyLeg } = useSearchResults()

    return (
        <Box display="flex" alignItems="center" justifyContent="space-between" width="100%" sx={{ p: 1 }}>
            <Box>
                {hasPrice && (
                    <>
                        <Typography variant="h5" fontWeight="bold">
                            {!!selectedPlan.planPricePrefix && selectedPlan.planPricePrefix} {selectedPlan.displayPrice}{' '}
                            {selectedPlan.isPerPaxPricingDefined && <PerAdultLabel />}
                        </Typography>
                        {selectedJourneyLeg == 0 && (
                            <Typography sx={{ fontSize: '13px', color: 'rgba(17, 163, 68, 1)' }}>
                                {exclusiveBenefits}
                            </Typography>
                        )}
                    </>
                )}
            </Box>

            <Button
                variant="customVariantPrimary"
                disabled={!hasPrice}
                onClick={handleFareFamilyBook}
                sx={theme => ({
                    // backgroundColor: hasPrice ? theme.palette.primary.main : theme.palette.grey[400],
                    borderRadius: '0.5rem',
                    px: 3,
                    py: 1.2,
                    boxShadow: 'none',
                    // '&:hover': {
                    //     backgroundColor: hasPrice ? theme.palette.secondary.main : theme.palette.grey[400],
                    //     color: hasPrice ? theme.palette.primary.main : 'inherit',
                    //     boxShadow: 'none'
                    // }
                })}
            >
                {t('Continue')}
            </Button>
        </Box>
    )
}

export default FareModalFooter
